// AUTO-GENERATED — DO NOT EDIT THIS FILE DIRECTLY.
//
// Synced from react/_shared/wallet/wallet_connectors.js — the SAME canonical
// buildWalletConnectors() that scripts/sync_wallet.sh copies into the
// wagmi.js-based apps (bankcoin-web, depositor-web-v2, ...). Reused here
// (not forked) so every app's "Connect a Wallet" list is identical and
// maximal — see CLAUDE.md "WalletConnect/Reown" rule.
//
// Synced by scripts/sync_wallet_app.sh on 2026-07-17T08:09:17Z.
//
// To make changes:
//   1. Edit react/_shared/wallet/wallet_connectors.js
//   2. Run ./scripts/sync_wallet_app.sh (wallet-app consumers) and/or
//      ./scripts/sync_wallet.sh (wagmi.js consumers)
//
// Editing this copy in place will be overwritten on next sync.
//
// ---------------------------------------------------------------

// react/_shared/wallet/wallet_connectors.js
//
// CANONICAL, SHARED wallet connector list for every aso React app (bankcoin-web,
// depositor-web-v2, …). This is the SINGLE SOURCE — edit it HERE, then run
// `scripts/sync_wallet.sh` to copy it into each consumer's src/lib/. The copies
// carry a DO-NOT-EDIT banner. (Vite/bare imports don't resolve across apps —
// each app has its own node_modules — so we copy-with-sync, same pattern as
// react/_shared/cookie-consent and react/_shared/i18n.)
//
// The whole point: one edit + one sync ⇒ EVERY app's "Connect a Wallet" list is
// identical and maximal.
//
// NO HARDCODED WALLET LIST. We enumerate EVERY wallet factory the installed
// RainbowKit exports via `import *`, so the list can never drift stale (a manual
// list had fallen ~8 months out of date). `npm update @rainbow-me/rainbowkit`
// brings new wallets in automatically — they appear in every app on the next
// sync with zero edits here.
//
// Per-app differences are PARAMETERS, not forks:
//   • appName     — shown in the WalletConnect pairing prompt
//   • projectId   — the shared Reown/WalletConnect project id
//   • recommended — app-specific wallets surfaced first (e.g. CryptoDeposit's
//                   custom "Krypty" wallet). bankcoin.capital passes none.

import { connectorsForWallets } from '@rainbow-me/rainbowkit';
import * as rkWallets from '@rainbow-me/rainbowkit/wallets';

// The most-used wallets, surfaced first. Everything else follows automatically.
// (Only names that actually exist in the installed RainbowKit are used.)
const TOP = [
  'metaMaskWallet', 'rainbowWallet', 'coinbaseWallet', 'walletConnectWallet',
  'rabbyWallet', 'trustWallet', 'ledgerWallet', 'okxWallet', 'phantomWallet',
  'uniswapWallet', 'binanceWallet', 'bybitWallet', 'injectedWallet', 'safeWallet',
  'braveWallet', 'zerionWallet',
];

/**
 * allWalletFactories — every exported wallet factory in the installed
 * RainbowKit (any export whose name ends in "Wallet" and is callable). Excludes
 * helpers like getWalletConnectConnector. Top wallets first, then the rest in
 * export order. This is what keeps the list maximal + self-updating.
 */
export function allWalletFactories() {
  const entries = Object.entries(rkWallets).filter(
    ([name, fn]) => typeof fn === 'function' && /Wallet$/.test(name),
  );
  const byName = Object.fromEntries(entries);
  const top = TOP.filter((n) => byName[n]).map((n) => byName[n]);
  const rest = entries.filter(([n]) => !TOP.includes(n)).map(([, fn]) => fn);
  return [...top, ...rest];
}

export const STANDARD_WALLETS = allWalletFactories();

/**
 * buildWalletConnectors — the identical, maximal connector set for every app.
 *
 * @param {object}  opts
 * @param {string}  opts.projectId     Reown/WalletConnect project id (shared).
 * @param {string}  opts.appName       Shown in the WC pairing prompt.
 * @param {Array}   [opts.recommended] App-specific wallet factories surfaced
 *                                     first (e.g. CryptoDeposit's Krypty).
 * @returns RainbowKit connectors (pass to wagmi createConfig).
 */
export function buildWalletConnectors({ projectId, appName, recommended = [] }) {
  const groups = [];
  if (recommended.length) {
    groups.push({ groupName: 'Recommended', wallets: recommended });
  }
  groups.push({
    groupName: recommended.length ? 'More wallets' : 'Connect a wallet',
    wallets: STANDARD_WALLETS,
  });
  return connectorsForWallets(groups, { appName, projectId });
}

export default buildWalletConnectors;
